import { QueryClient } from "@tanstack/react-query";

export const configuredQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnWindowFocus: false,
    },
  },
});
